import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'
import { teamTagListQueryOptions } from '@/modules/team-tag/team-tag.hooks'

export const teamTagRoute = createRoute({
  path: '/team-tags',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const teamTagListRoute = createRoute({
  getParentRoute: () => teamTagRoute,
  path: '/',
  beforeLoad: async ({ preload }) =>
    routeHasPermission(
      preload,
      'team-tags.list',
      'Takım etiketi listesine erişim izniniz yok.'
    ),
  head: () => ({ meta: [{ title: 'Takım Etiketleri' }] }),
  loader: async () => {
    await queryClient.ensureQueryData(teamTagListQueryOptions({ page: 1 }))
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/team-tag/pages/list-team-tag.page')
  ),
})
